import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import {
  ALL_CUSTOMERS,
  GET_ALL_CUSTOMERS,
  GET_ALL_OFFICES_BY_CUSTOMER,
  ALL_OFFICES_BY_CUSTOMER,
  EXPORT_FORM_101,
  EXPORT_FORM_101_REQUEST_ERROR,
  SET_EXPORT_FORM_101_REQUEST_ERRORS,
  GET_ALL_SECTIONS_BY_OFFICE,
  ALL_SECTIONS_BY_OFFICE,
} from '@/types/customer.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Grid } from '@/models/Grid.model';
import { ExportForm101RequestModel } from '@/models/backoffice/ExportForm101RequestModel';
import { GET_USER_DETAILS } from '@/types/lobby.types';
import { UserData } from '@/models/UserDetails.model';

@Component({})
export default class ExportForms101Component extends Vue {

  @Inject() public $validator: any;

  @Action(GET_ALL_CUSTOMERS, StoreNamespace.CUSTOMER) public getAllCustomers;
  @Action(GET_ALL_OFFICES_BY_CUSTOMER, StoreNamespace.CUSTOMER) public getAllOfficesByCustomer;
  @Action(GET_ALL_SECTIONS_BY_OFFICE, StoreNamespace.CUSTOMER) public getAllSectionByOffice;
  @Action(EXPORT_FORM_101, StoreNamespace.CUSTOMER) public createExportForm101Request;
  @Action(GET_USER_DETAILS, StoreNamespace.LOBBY) public getUserDetails;

  @Mutation(SET_EXPORT_FORM_101_REQUEST_ERRORS, StoreNamespace.CUSTOMER) public setExportForm101RequestErrors;

  @Getter(ALL_CUSTOMERS, StoreNamespace.CUSTOMER) public allCustomers!: Grid;
  @Getter(ALL_OFFICES_BY_CUSTOMER, StoreNamespace.CUSTOMER) public allOfficesByCustomer!: Grid;
  @Getter(ALL_SECTIONS_BY_OFFICE, StoreNamespace.CUSTOMER) public allSectionsByOffice!: Grid;

  @Getter(EXPORT_FORM_101_REQUEST_ERROR, StoreNamespace.CUSTOMER)
  public exportForm101Errors!: string[];

  public mounted() {
    this.getAllCustomers();
    this.getUserDetails()
      .then((data: UserData) => {
        if (data.emailAddress) { this.exportForm101Request.email = data.emailAddress }
      });
    this.setExportForm101RequestErrors([]);
  }

  private get offices() {
    return this.exportForm101Request.indexNum ? this.allOfficesByCustomer.results : [];
  }

  private get sections() {
    return Array.isArray(this.exportForm101Request.offices) && this.exportForm101Request.offices.length > 0 ? this.allSectionsByOffice.results : [];
  }

  private static getEmptyForm101Request(): ExportForm101RequestModel {
    return {
      indexNum: null,
      taxYear: new Date().getFullYear(),
      offices: [],
      sectionNum: null,
      email: ''
    };
  }

  public exportForm101Request: ExportForm101RequestModel = ExportForms101Component.getEmptyForm101Request();
  private yearsOptions: number[] = [new Date().getFullYear() - 2, new Date().getFullYear() - 1,
    new Date().getFullYear(), new Date().getFullYear() + 1];
  private cleared = false;


  public onUpdateIndexNum(indexNum) {
    if (indexNum) {
      this.exportForm101Request.indexNum = indexNum;
      this.getAllOfficesByCustomer(this.exportForm101Request.indexNum);
    }
    this.exportForm101Request.offices = [];
  }

  public onUpdateOfficeNum(offices) {
    if (Array.isArray(offices) && offices.length > 0) {
      this.exportForm101Request.offices = offices;
      this.getAllSectionByOffice(this.exportForm101Request.offices[0]);
    }
    this.exportForm101Request.sectionNum = null;
  }

  public onExportRequest() {
    this.createExportForm101Request(this.exportForm101Request);
    this.onClear();
  }

  private onClear() {
    this.cleared = true;
    this.exportForm101Request = ExportForms101Component.getEmptyForm101Request();
    setTimeout(() => {
      this.cleared = false;
      this.exportForm101Request = ExportForms101Component.getEmptyForm101Request();
    });
  }

  private beforeDestroy() {
    this.setExportForm101RequestErrors([]);
  }
}

